import React from 'react';
import SurveyGizmoIframe from './SurveyGizmoIframe';

const QuestionsBox = () => {
  return (
    <div className="ie--card">
      <div className="ie--card--body">
        <div className="ie--card--col">
          <h2 className="ie--card--title">Create Questionnaire</h2>
          <div className="ie--dictionary--info">
            <p>
              Create and edit the Turn-Key Omnibus survey using the form below.
            </p>
            <p>
              Please note: though you are free to add as many questions as you
              feel appropriate, the estimated cost is based on a{' '}
              <strong>maximum of 10 questions</strong>. Surveys longer than that
              may exceed the estimated cost and will require your approval to
              field. Once you have submitted the survey, our experts will review
              it to ensure you get the best data.
            </p>
            <p>
              MRI-Simmons will append a standardized set of questions to your
              survey. This is necessary to facilitate the automated fusion but
              does not affect your estimated cost.
            </p>
          </div>
          <SurveyGizmoIframe />
        </div>
      </div>
    </div>
  );
};

export default QuestionsBox;
